import {TextInput, TextInputProps} from '@mantine/core'
import {useEffect, useState} from 'react'
import {fmtNum, parseNum} from 'shared/format'
import {isNullOrEmpty} from 'shared/collection'

/** A number input control that allows for a variety of number formats */
export const StringNumberInput = ({
  value,
  error,
  onChange,
  fmt = fmtNum,
  selectOnFocus,
  ...props
}: Omit<TextInputProps, 'onChange'> & {
  onChange: (v: number) => void
  fmt?: (v: number) => string
  selectOnFocus?: boolean
}) => {
  const [valueText, setValueText] = useState(value?.toString() ?? '') // the text is the source of truth
  // separate state for text because there are intermediate states (e.g. typing 0.0001)
  useEffect(() => {
    // update the text only if there is a conflict
    if (parseNum(valueText) != value) setValueText(value ? fmt(Number(value)) : '')
  }, [value])

  return (
    <TextInput
      className=''
      {...props}
      value={valueText}
      onChange={e => {
        setValueText(e.target.value)
        const newValue = parseNum(e.target.value)
        if (newValue != null && newValue != value && Number.isFinite(newValue)) {
          onChange?.(newValue)
        }
      }}
      onFocus={e => {
        if (selectOnFocus) {
          e.target.select()
        }
        props.onFocus?.(e)
      }}
      error={error ?? (!isNullOrEmpty(valueText) && parseNum(valueText) == null) ? 'Enter a valid number' : error}
    />
  )
}
